module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/announcement/announcement.component.css
// module id = ./src/app/announcement/announcement.component.css
// module chunks = main